import { DATE_TIME_FORMAT_1 } from "@app/constants";
import VasService from "@app/services/http/vas.service";
import { VasHistory } from "@app/types";
import { formatDateTime, formatMoneyVN } from "@app/utils/util";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import { useEffect, useState } from "react";

function VasTab() {
  const [vasHistories, setVasHistories] = useState<VasHistory[]>([]);

  const { abortController } = useCancellationRequest();

  useEffect(() => {
    VasService.getVasHistories(abortController.signal).then((res) => {
      setVasHistories(res.data.items);
    });
  }, []);

  return (
    <div className="mt-10">
      {vasHistories.length ? (
        <div className="flex flex-wrap gap-8">
          {vasHistories.map((vasHistories) => (
            <div
              key={vasHistories.id}
              className="w-[400px] min-h-[130px] bg-white rounded-md p-5"
            >
              <p className="font-[SVN-Gilroy]">
                Thời gian:{" "}
                {formatDateTime(vasHistories.createdDate, DATE_TIME_FORMAT_1)}
              </p>
              <p className="mt-2 font-[SVN-Gilroy]">
                Kas:{" "}
                <strong
                  className={
                    vasHistories.point > 0 ? "text-[#00A653]" : "text-[#FC4040]"
                  }
                >
                  {vasHistories.point > 0
                    ? `+${formatMoneyVN(vasHistories.point)}`
                    : formatMoneyVN(vasHistories.point)}
                </strong>
              </p>
              <p className="mt-2 font-[SVN-Gilroy]">
                Nội dung: {vasHistories.message}
              </p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default VasTab;
